import React, { useState, useCallback, useMemo } from "react";
import styles from "./Control.module.sass";
import cn from "classnames";
import Icon from "../../../../components/Icon";
import ModalDocument from "../../../../components/ModalViewDocument";
import {
  downloadDocument,
  deleteDocument, // Seul deleteDocument est nécessaire pour les services de document ici
} from "../../../../services/documents.service";
import { showSuccess, showInfo, showError } from "../../../../services/toast.service";

const Control = ({ className, document: documentData, onDocumentChange }) => {
  const [visibleModalProduct, setVisibleModalProduct] = useState(false);

  // Fonction pour recharger la page
  // Utilisez cette fonction avec prudence ; souvent, mettre à jour l'état du parent est préférable.
  const reloadPage = useCallback(() => {
    window.location.reload();
  }, []);

  // Handler pour le téléchargement du document
  const handleDownload = useCallback(async () => {
    if (!documentData) {
      showInfo("Aucun document à télécharger.");
      return;
    }
    // Si le document a déjà une URL directe, l'ouvrir dans un nouvel onglet
    if (documentData.downloadUrl || documentData.url) {
      const url = documentData.downloadUrl || documentData.url;
      window.open(url, '_blank');
      showSuccess("Document ouvert dans un nouvel onglet.");
    } else {
      // Sinon, appeler le service de téléchargement (si applicable)
      const success = await downloadDocument(documentData);
      if (success) {
        showSuccess("Document téléchargé avec succès !");
      } else {
        showError("Échec du téléchargement du document.");
      }
    }
  }, [documentData]);

  // Handler pour supprimer le document
  const handleDelete = useCallback(async () => {
    if (!documentData) {
      showInfo("Aucun document à supprimer.");
      return;
    }
    const success = await deleteDocument(documentData); // Appel au service de suppression
    if (success) {
      showSuccess("Document supprimé avec succès !");
      if (onDocumentChange) {
        onDocumentChange(); // Notifier le parent pour rafraîchir la liste
      }
    } else {
      showError("Échec de la suppression du document.");
    }
  }, [documentData, onDocumentChange]);

  // Handler pour l'affichage de la modale d'aperçu
  const handleExpand = useCallback(() => {
    setVisibleModalProduct(true);
  }, []);

  // Liste des actions disponibles, calculée avec useMemo
  const actions = useMemo(() => {
    // Les actions de confirmation et de refus ont été supprimées.
    return [
      {
        icon: "download",
        action: handleDownload,
        title: "Télécharger le document",
      },
      {
        icon: "trash",
        action: handleDelete,
        title: "Supprimer le document",
      },
      {
        icon: "expand",
        action: handleExpand,
        title: "Voir l'aperçu",
      },
    ];
  }, [handleDownload, handleDelete, handleExpand]); // Les dépendances sont uniquement les handlers utilisés

  return (
    <>
      <div className={cn(styles.control, className)}>
        {actions.map((x, index) => (
          <button
            className={styles.button}
            key={index} // Idéalement, utiliser un ID unique pour la clé si les actions peuvent changer d'ordre
            onClick={x.action}
            title={x.title || ''}
          >
            <Icon name={x.icon} size="20" />
          </button>
        ))}
      </div>
      <ModalDocument
        visible={visibleModalProduct}
        onClose={() => setVisibleModalProduct(false)}
        documentData={documentData}
      />
    </>
  );
};

export default Control;